import { createSelector, createStructuredSelector } from 'reselect';
import _get from 'lodash/get';

export const rootDomain = ({ root }) => root || {};
export const appDataDomain = ({ Data }) => Data || {};
export const locationsDomain = ({ root }) => _get(root, 'locationsDetails') || {};

export const appDataSelect = createSelector(
  appDataDomain,
  state => state
);

export const isAppSelect = createSelector(
  appDataDomain,
  ({ isApp }) => isApp || false
);

export const localeSelect = createSelector(
  appDataDomain,
  ({ locale }) => locale || 'zh_CN'
);

export const localeHyphenSelect = createSelector(
  appDataDomain,
  ({ locale }) => locale?.replace('_', '-') || 'zh-CN'
);

export const showLoaderSelect = createSelector(
  rootDomain,
  ({ globalLoader }) => _get(globalLoader, 'show')
);

export const showErrorSelect = createSelector(
  rootDomain,
  ({ globalError }) => _get(globalError, 'error')
);

export const csrfTokenSelect = createSelector(
  appDataDomain,
  ({ csrfToken }) => csrfToken
);

export const cxLinksSelect = createSelector(
  appDataDomain,
  ({ cxLinks }) => cxLinks
);

export default createStructuredSelector({
  appData: appDataSelect,
  locale: localeSelect,
  localeHyphen: localeHyphenSelect,
  showLoader: showLoaderSelect,
  showError: showErrorSelect,
  csrfToken: csrfTokenSelect,
  isApp: isAppSelect,
  cxLinks: cxLinksSelect,
});
